import { makeStyles } from '@mui/styles';

export const MULTIMEDIA_MANAGER_TABS_WIDTH = 155;

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    borderRight: `solid 1px ${theme.palette.grey[200]}`,
    position: 'relative',
    zIndex: 3,
    minWidth: `${MULTIMEDIA_MANAGER_TABS_WIDTH}px`,
  },
  tab: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    padding: theme.spacing(1, 2),
  },
  tabIcon: {
    marginBottom: `0 !important`,
  },
  tabLabel: {
    paddingLeft: theme.spacing(1.5),
    textAlign: 'left',
  },
  indicator: {
    background: theme.palette.primary.main,
  },
}));
